import React from 'react'
import ReactDOM from 'react-dom'


let registeredComponents = []
let handlers = []

let IGNORE_CLASS = 'ignore-onclickoutside'

let isSourceFound = function (source, localNode) {
  if (source === localNode) {
    return true
  }
  return source.classList.contains(IGNORE_CLASS)
}

export  default (WrappedComponent, config) => {
  let instance = null
  return class extends React.Component {
    constructor(props) {
      super(props)
      // this.wrappedRef = React.createRef()
      this.wrappedRef = null
    }

    componentDidMount() {

      let fn = this.__outsideClickHandler = (function (localNode, eventHandler) {
        return function (event) {
          event.stopPropagation()
          let source = event.target
          let found = false
          while (source.parentNode) {
            found = isSourceFound(source, localNode)
            if (found) return
            source = source.parentNode
          }
          eventHandler(event)
        }
      }(ReactDOM.findDOMNode(this), this.handleClickOutside.bind(this)))

      let pos = registeredComponents.length
      registeredComponents.push(this)
      handlers[pos] = fn

      if (!this.props.disableOnClickOutside) {
        this.enableOnClickOutside()
      }
    }

    componentWillUnmount() {
      this.disableOnClickOutside()
      this.__outsideClickHandler = false
      let pos = registeredComponents.indexOf(this)
      if (pos > -1) {
        if (handlers[pos]) {
          handlers.splice(pos, 1)
          registeredComponents.splice(pos, 1)
        }
      }
    }

    handleClickOutside(event) {
      if (this.wrappedRef.handleClickOutside)
        this.wrappedRef.handleClickOutside(event)
      else if (config && config.handleClickOutside) {
        this.wrappedRef[config.handleClickOutside](event)
      }
    }

    enableOnClickOutside() {
      let fn = this.__outsideClickHandler
      document.addEventListener('mousedown', fn)
      document.addEventListener('touchstart', fn)
    }

    disableOnClickOutside() {
      let fn = this.__outsideClickHandler
      document.removeEventListener('mousedown', fn)
      document.removeEventListener('touchstart', fn)
    }

    static getInstance(){
      return instance
    }

    render() {
      return WrappedComponent ? <WrappedComponent ref={(wrapped)=>{this.wrappedRef = instance = wrapped}} {...this.props} {...this.state} /> : null
    }
  }
}


